var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-column-month font-weight-light",style:(`
    z-index: ${_vm.z_index};
    left: ${_vm.sticky_left};
    width: calc((var(--workpackage_width) + 8px) * var(--taktplan_zoom) * ${_vm.duration?_vm.duration:1});
    `)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }